import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  constructor() {
    // localStorage.setItem(this.keyLanguage, "fr");
  }

  keyLanguage = "userLanguage";
  private _userLanguage : string  = "fr"
  public currentLanguage  = new BehaviorSubject<string | null>(localStorage.getItem(this.keyLanguage));
  // private supportedLanguage = ['en','fr'];
  private supportedLanguage = ['fr'];


  initLanguage(){
    // const lang = localStorage.getItem(this.keyLanguage);

    // if(lang != null){
    //   this._userLanguage = lang;
    // }else{
    //   const browserLang = navigator.language.split('-')[0];
    //   this._userLanguage = "fr";

    //   if(this.supportedLanguage.includes(browserLang)){
    //     this._userLanguage = browserLang;
    //     localStorage.setItem(this.keyLanguage,browserLang);
    //   }

    //   this.currentLanguage.next(localStorage.getItem(this.keyLanguage));
    // }
  }

  setLanguage( lang : string){
    // lang = 'fr';
    this._userLanguage = lang;
    localStorage.setItem(this.keyLanguage, lang);
    this.currentLanguage.next(localStorage.getItem(this.keyLanguage));
    // this.translate.use(this._userLanguage);
  }

  get userLanguage() : string{
    return this._userLanguage;
  }

  get availableLanguage(): string[]{
    return this.supportedLanguage;
  }
}
